import dispatcher from "../Dispatcher/Dispatcher";
import config from "../Config/Config";
import httpRequest from "../HttpRequests/HttpRequest";
import ExceptionConstants from "../Constants/ExceptionAnalysisConstants";

class ExceptionAnalysis_Actions {
  getExceptionLogs(Id) {
    httpRequest(
      config.webServiceURL + "/ExceptionAnalysis/Get/" + Id,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: ExceptionConstants.GET_SELECTED_EXCEPTION_LOG_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: ExceptionConstants.GET_SELECTED_EXCEPTION_LOG_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  getExceptionAnalysisLogs(filterItem) {
    let payLoad;
    if (filterItem.IsValidation === -1) {
      payLoad = {
        MethodInfo: filterItem.MethodInfo,
        OccurredInDays: filterItem.OccurredInDays,
      };
    } else {
      payLoad = {
        MethodInfo: filterItem.MethodInfo,
        OccurredInDays: filterItem.OccurredInDays,
        LogType: filterItem.IsValidation,
      };
    }
    httpRequest(
      config.webServiceURL + "/ExceptionAnalysis/ExceptionAnalysisLogs",
      "POST",
      JSON.stringify(payLoad),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: ExceptionConstants.GET_ALL_EXCEPTION_LOG_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: ExceptionConstants.GET_ALL_EXCEPTION_LOG_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  deleteException(exceptionId) {
    httpRequest(
      config.webServiceURL + "/ExceptionAnalysis/" + exceptionId,
      "DELETE",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: ExceptionConstants.DELETE_EXCEPTION_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: ExceptionConstants.DELETE_EXCEPTION_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  deleteMultipleException(filterItem) {
    let payLoad;
    if (filterItem.IsValidation === -1) {
      payLoad = {
        MethodInfo: filterItem.MethodInfo,
        OccurredInDays: filterItem.OccurredInDays,
      };
    } else {
      payLoad = {
        MethodInfo: filterItem.MethodInfo,
        OccurredInDays: filterItem.OccurredInDays,
        LogType: filterItem.IsValidation,
      };
    }

    httpRequest(
      config.webServiceURL + "/ExceptionAnalysis",
      "PUT",
      JSON.stringify(payLoad),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: ExceptionConstants.DELETE_MUL_EXCEPTION_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: ExceptionConstants.DELETE_MUL_EXCEPTION_FAILURE,
            result: message,
          });
        }
      }
    );
  }
}
export default new ExceptionAnalysis_Actions();
